//@ts-nocheck
import React, { createContext, useState } from "react";
const GeoFenceContext = createContext({
	metaData: [],
	setMetaData: (metaData: object) => {},
	geoFence: {},
	setGeoFence: (geoFence: object) => {},
	tokenId: [],
	setTokenID: (tokenId: string) => {},
	details: {
		price: 0,
		tags: [],
		type: "",
		userLocation: {
			geometry: { coordinates: [0, 0] },
		},
		topUp: 0,
	},
	setDetails: (details: object) => {},
});

type METADATA = {
	mint: Mint;
	metadata: Metadata;
};

const GeoFenceContextProvider = ({ children }) => {
	const [metaData, setMetaData] = useState<any>([]);
	const [geoFence, setGeoFence] = useState({});
	const [tokenId, setTokenID] = useState([]);
	const [details, setDetails] = useState({
		price: 0,
		tags: [],
		type: "",
		userLocation: {
			geometry: { coordinates: [0, 0] },
		},
		stashId: "",
		topUp: 0,
	});

	return (
		<GeoFenceContext.Provider
			value={{
				metaData,
				setMetaData,
				geoFence,
				setGeoFence,
				tokenId,
				setTokenID,
				setDetails,
				details,
			}}
		>
			{children}
		</GeoFenceContext.Provider>
	);
};

export { GeoFenceContext, GeoFenceContextProvider };
